// Linkify URLs and render them as clickable anchors. Keeps line breaks.
import React from "react";

const URL_RE = /(https?:\/\/[^\s<>"]+)/g;

export default function MessageContent({ text }) {
  if (!text) return null;
  const parts = [];
  let lastIdx = 0;
  let m;
  while ((m = URL_RE.exec(text)) !== null) {
    if (m.index > lastIdx) parts.push(text.slice(lastIdx, m.index));
    parts.push(
      <a
        key={m.index}
        href={m[0]}
        target="_blank"
        rel="noopener noreferrer"
        className="underline decoration-primary/60 hover:decoration-primary text-primary break-all"
      >
        {m[0]}
      </a>
    );
    lastIdx = m.index + m[0].length;
  }
  if (lastIdx < text.length) parts.push(text.slice(lastIdx));
  return <span className="whitespace-pre-wrap">{parts}</span>;
}
